export const environment:{[key: string]: any} = {
  frontendUrl: 'https://app.shrimp.de',
  shortnameRedirectUrl: 'https://go.shrimp.de',
  backendBaseUrl: 'https://backend.shrimp.de',
  backendPdfUrl: 'https://backend-pdf.shrimp.de',
  dev: false,
  httpDefaultTimeout: 80000,
  idps: [{
    name: 'satosa',
    loginEndpoint: 'login_satosa',
    description: '',
  },{
    name: 'local',
    loginEndpoint: '*local',
    description: '',
  },{
    name: 'ac',
    loginEndpoint:'login-ac',
    description: '',
  }]
}
